<template>
    <QualificationField
        :title="$t('profile.vetting.qualification.interest.interim.title')"
        data-testid="admin-section-tabs-qualification-interest-interim"
    >
        <VJoyToggle
            v-if="profileQualificationStore.inEditMode"
            v-bind="{label: contentAsText}"
            v-model="profileQualificationStore.qualificationUpdateForm.interestInInterim"
            data-testid="vetting-interest-interim"
        ></VJoyToggle>
        <span v-else data-testid="vetting-interest-interim">{{ contentAsText }}</span>
    </QualificationField>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {VJoyToggle} from '@maltjoy/core-vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const profileQualificationStore = useProfileQualificationStore();

    const contentAsText = computed(() => {
        if (profileQualificationStore.qualificationUpdateForm.interestInInterim) {
            return 'Yes';
        } else {
            return 'No';
        }
    });
</script>
